import { Theme, lighten } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const cardStyles = {
  card: (theme: Theme): SystemStyleObject<Theme> => ({
    padding: 2,
    borderRadius: 0,
    background: theme.palette.background.default,
    "& img": {
      borderRadius: 0,
    },
  }),
  plain: (): SystemStyleObject<Theme> => ({
    background: "transparent",
    padding: 0,
  }),
  lighter: (theme: Theme): SystemStyleObject<Theme> => ({
    background: lighten(theme.palette.background.paper, 0.1),
  }),
  purple: (theme: Theme): SystemStyleObject<Theme> => ({
    background: theme.palette.background.paper,
  }),
  light: (theme: Theme): SystemStyleObject<Theme> => ({
    background: theme.palette.background.paper,
  }),
  clickable: (theme: Theme): SystemStyleObject<Theme> => ({
    cursor: "pointer",
    "&:hover": {
      boxShadow: `${theme.palette.secondary.main} 0px 0px 20px -5px`,
    },
  }),
  border: (theme: Theme): SystemStyleObject<Theme> => ({
    border: `1px solid ${theme.palette.secondary.main}`,
  }),
  shadow: (): SystemStyleObject<Theme> => ({
    boxShadow: "rgb(0 0 0 / 30%) 0px 0px 25px",
  }),
};

export default cardStyles;
